import { createFeatureSelector, createSelector } from '@ngrx/store';
import {  AgreementState, agreementFeatureKey } from './agreement.reducer';

export const selectAgreementFeature = createFeatureSelector<AgreementState>(agreementFeatureKey);

export const selectAgreement = createSelector(selectAgreementFeature,(state) => state.agreement??"");
